import { storeDebug } from "~lib/debug";

export const log = (actionName: string, payload?: Record<string, any>) => {
  storeDebug(`%c Action ${actionName} `, "background: #222; color: #bada55", {
    payload,
  });
};
